// Blog byline rules (owner rulings 08/03/2026 + 08/06/2026, FRIDGE-131):
// - "Fridge.com Editorial Team" is the SCHEMA author ONLY — the Organization
//   node in the article JSON-LD. It is NEVER rendered as a visible on-page
//   byline (the owner's 08/06/2026 clarification: "just meant to be in meta
//   stuff as the author — but NEVER on page").
// - Visible bylines show the article's person author (articles.author_name,
//   restored 08/06/2026 on the owner's direct order). When author_name is the
//   team byline or empty, display surfaces render NO byline rather than ever
//   showing the team name.

export const TEAM_BYLINE = 'Fridge.com Editorial Team'

export function isTeamByline(name?: string | null): boolean {
  if (!name) return true
  return /fridge\.com/i.test(name) || /editorial team|^team$/i.test(name)
}

/**
 * The visible byline for a display surface: the person author's name, or
 * null when nothing may render. Never returns the team byline — that name
 * belongs to the schema layer only (owner rule, 08/06/2026).
 */
export function formatByline(authorName?: string | null): string | null {
  if (!authorName || isTeamByline(authorName)) return null
  return authorName
}
